import React from "react";
import { Menu } from "@ark-ui/react";

export interface DropdownMenuItem {
  value: string;
  label: string;
  icon?: React.ReactNode;
  color?: string;
  onSelect?: () => void;
}

interface DropdownMenuProps {
  trigger: React.ReactNode;
  items: DropdownMenuItem[];
  selectedValue?: string;
  positioning?: { placement?: "top-start" | "top-end" | "bottom-start" | "bottom-end" };
}

export function DropdownMenu({ trigger, items, selectedValue, positioning }: DropdownMenuProps) {
  return (
    <Menu.Root
      positioning={{ placement: "bottom-start", ...positioning }}
      closeOnSelect
    >
      <Menu.Trigger asChild>{trigger}</Menu.Trigger>
      <Menu.Positioner style={{ zIndex: 50 }}>
        <Menu.Content
          style={{
            background: "rgb(var(--color-surface))",
            border: "1px solid rgb(var(--color-border))",
            borderRadius: "0.5rem",
            boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
            overflow: "hidden",
            minWidth: "168px",
            outline: "none",
          }}
        >
          {items.map((item, i) => {
            const isSelected = item.value === selectedValue;
            return (
              <Menu.Item
                key={item.value}
                value={item.value}
                onSelect={item.onSelect}
                style={{
                  borderTop: i === 0 ? "none" : "1px solid rgb(var(--color-foreground) / 0.05)",
                  background: isSelected && item.color ? `${item.color}12` : undefined,
                  color: isSelected && item.color ? item.color : undefined,
                }}
                className="w-full px-3.5 py-2.5 text-[13px] text-secondary flex items-center gap-2.5 cursor-pointer bg-transparent border-none font-sans outline-none transition-colors duration-100 data-[highlighted]:bg-foreground/[0.04] data-[highlighted]:text-foreground"
              >
                {item.color ? (
                  <span
                    className="w-2 h-2 rounded-full shrink-0 transition-colors duration-150"
                    style={{ background: isSelected ? item.color : `${item.color}55` }}
                  />
                ) : item.icon ? (
                  <span className="shrink-0 opacity-70">{item.icon}</span>
                ) : null}
                {item.label}
                {isSelected && (
                  <span className="ml-auto text-[10px] opacity-60">✓</span>
                )}
              </Menu.Item>
            );
          })}
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
}
